<div class="row">
    <div class="col-sm-4 ">
        <div class="col-sm-12 border rounded-2" style="padding: 15px;">
            <div class="row">
                <div class="input-group mb-3">
                    <input #input type="file" class="form-control" aria-label="file example"
                        (change)="handleFileInput($event.target)" id="uploadFile" aria-describedby="uploadFile"
                        required>
                    <button class="btn btn-outline-secondary" *ngIf="btnViewFile" type="button" (click)="getFile()"
                        id="uploadFile">Visualizar</button>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <button type="button" pButton (click)="upload()" class="btn btn-primary float-start {{disabled}}"
                        label="Upload" >Upload</button>
                        <div *ngIf="spin" class="spinner-border float-end" style="width: 2rem; height: 2rem;" role="status">
                            <span class="sr-only"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-8" unselectable="on" onselectstart="return false;" onmousedown="return false;">
        <h1 class="display-2 text-center user-select-none" *ngIf="pdfSrc === undefined"
            style="font-weight: bold; padding-top: 1%; color: rgb(209, 209, 209);">PDF</h1>
        <pdf-viewer [src]="pdfSrc" *ngIf="pdfSrc !== undefined" [render-text]="true" [render-text-mode]="0"
            [external-link-target]="'none'" [show-borders]="true" [show-all]="btnViewMore" style="display: block;">
        </pdf-viewer>
        <button type="button" *ngIf="!btnViewMore && pdfSrc !== undefined" pButton (click)="btnViewMore = true"
            class="btn btn-outline-dark border-0 float-end btn-lg" label="view more">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-chevron-down" viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
            </svg>
        </button>
        <button type="button" *ngIf="btnViewMore && pdfSrc !== undefined" pButton (click)="btnViewMore = false"
            class="btn btn-outline-dark border-0 float-end btn-lg" label="view more">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-up"
                viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                    d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z" />
            </svg>
        </button>
    </div>
</div>